<template>
    <div class="table-responsive">
        <vue-perfect-scrollbar style="height: 408px">
            <v-data-table
                v-if="(notifications || []).length > 0"
                :headers="headers"
                :items="notifications"
                :no-data-text="$t('lang.no_data_available')"
                hide-actions
            >
                <template slot="items" slot-scope="props">
                    <tr class="clickable" @mouseup.left="openNotificationForm(props.item)">
                        <td>
                            <span
                                ><v-icon>{{ props.item.notify_type }}</v-icon></span
                            >
                        </td>
                        <td>{{ props.item.notify_place }}</td>
                        <td>{{ props.item.full_name }}</td>
                        <td>{{ props.item.subject }}</td>
                        <td>{{ props.item.date_created }}</td>
                    </tr>
                </template>
            </v-data-table>
        </vue-perfect-scrollbar>
        <bc-dialog :value="notification_dialog" fullscreen>
            <v-card>
                <v-form ref="form_notification">
                    <v-card-title>
                        <span class="headline">{{ notification.notification_id ? $t("lang.edit_notification") : $t("lang.add_notification") }}</span>
                        <v-spacer horizontal></v-spacer>

                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeNotificationDialog"
                            :dialog-status="notification_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <vue-perfect-scrollbar class="scroll-area" :style="$bp.xs ? null : 'max-height: calc(100vh - 160px);'">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs10>
                                        <v-text-field
                                            v-focus="notification_dialog"
                                            v-model="notification.notification_id"
                                            :label="$t('lang.notification_id')"
                                            :counter="showCounter(notification.notification_id, 'notifications.notification_id')"
                                            :rules="ifValid('notifications.notification_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs2>
                                        <v-switch
                                            v-model="notification.modal"
                                            :label="`${notification.modal == 1 ? $t('lang.modal') : $t('lang.non_modal')}`"
                                            true-value="1"
                                            false-value="0"
                                        >
                                        </v-switch>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="notification.subject"
                                            :label="$t('lang.subject')"
                                            :counter="showCounter(notification.subject, 'notifications.subject')"
                                            :rules="ifValid('notifications.subject')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea
                                            style="padding-top: 0px !important"
                                            :value="notification.message"
                                            :label="`${$t('lang.message')} *`"
                                            hide-details
                                            outline
                                            scroll
                                            rows="20"
                                            :rules="ifValid('notifications.message')"
                                        ></v-textarea>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-text-field
                                            v-model="notification.object_name"
                                            :label="$t('lang.object_name')"
                                            :counter="showCounter(notification.object_name, 'notifications.object_name')"
                                            :rules="ifValid('notifications.object_name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-text-field
                                            v-model="notification.object_id"
                                            :label="$t('lang.object_id')"
                                            :counter="showCounter(notification.object_id, 'notifications.object_id')"
                                            :rules="ifValid('notifications.object_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-text-field
                                            v-model="notification.file"
                                            :label="$t('lang.file')"
                                            :counter="showCounter(notification.file, 'notifications.file')"
                                            :rules="ifValid('notifications.file')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="notification.icon"
                                            :label="$t('lang.icon')"
                                            :counter="showCounter(notification.icon, 'notifications.icon')"
                                            :rules="ifValid('notifications.icon')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="notification.icon_class"
                                            :label="$t('lang.icon_class')"
                                            :counter="showCounter(notification.icon_class, 'notifications.icon_class')"
                                            :rules="ifValid('notifications.icon_class')"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </vue-perfect-scrollbar>
                    </v-card-text>
                </v-form>
                <v-card-actions>
                    <v-btn v-if="notification.notification_id" color="error" @mouseup.left="$refs.delete_notifications.openDialog()">{{
                        $t("lang.delete")
                    }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="closeNotificationDialog()">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @click="saveNotifications">{{ $t("lang.save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <delete-confirmation-dialog
            ref="delete_notifications"
            :heading="$t('lang.delete_notification')"
            :message="$t('lang.confirm_delete_message')"
            @onConfirm="deleteNotifications(notification.notification_id)"
        ></delete-confirmation-dialog>
        <app-section-loader :status="loader"></app-section-loader>
    </div>
</template>

<script>
import api from "Api";
import { mapActions, mapState, mapMutations } from "vuex";
import AppSectionLoader from "Components/AppSectionLoader/AppSectionLoader";
export default {
    data() {
        return {
            loader: false,
            invoice: [],
            headers: [
                {
                    text: "",
                    sortable: false,
                    align: "center",
                    width: "5%",
                },
                { text: this.$t("lang.notify_place"), sortable: false, width: "20%" },
                { text: this.$t("lang.name"), sortable: false },
                { text: this.$t("lang.subject"), sortable: false },
                {
                    text: this.$t("lang.date_sent"),
                    sortable: false,
                },
            ],
            notification: {},
            notification_dialog: false,
        };
    },
    mounted() {
        this.refresh();
    },
    computed: {
        ...mapState({
            notifications: (state) => state.notifications.notifications,
            rules_notifications: (state) => state.notifications.rules_notifications,
        }),
    },
    methods: {
        ...mapActions(["fetchNotifications", "saveNotification", "deleteNotification", "fetchMeNotifications", "fetchPeople"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openNotificationForm(item = null) {
            if (this.$refs.form_notification) item ? this.$refs.form_notification.resetValidation() : this.$refs.form_notification.reset();

            this.notification = item != null ? this.assignObj2(item, this.rules_notifications) : {};
            this.notification_dialog = true;
        },
        saveNotifications() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_notification")) {
                    let body = this.prepForm(this.notification, this.rules_notifications);

                    this.saveNotification({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            this.refresh();
                            this.closeNotificationDialog();
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteNotifications(id = null) {
            this.deleteNotification({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getNotifications();
                    this.closeNotificationDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeNotificationDialog() {
            this.notification_dialog = false;
            this.$refs.delete_notifications.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        refresh() {
            this.loader = true;
            this.$store.commit("mutate", {
                property: "notifications",
                with: [],
            });
            this.fetchNotifications({ body: { options: 1 } }).then((data) => {
                this.loader = false;
            });
        },
    },
    components: {
        AppSectionLoader,
    },
};
</script>
